import { render, staticRenderFns } from "./ZCpochanqiyeduifu.vue?vue&type=template&id=f80a60d6&scoped=true"
import script from "./ZCpochanqiyeduifu.vue?vue&type=script&lang=js"
export * from "./ZCpochanqiyeduifu.vue?vue&type=script&lang=js"
import style0 from "./ZCpochanqiyeduifu.vue?vue&type=style&index=0&id=f80a60d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80a60d6",
  null
  
)

export default component.exports